import React, { useState, useEffect } from 'react';
import { getMetrics } from '../utils/api'
import Row from 'react-bootstrap/Row';
import Header from './Header';
import Error from './Error';
import Loader from './Loader';
import StackedKeyIndicatorChart from './StackedKeyIndicatorChart'
import { Button, ButtonGroup } from 'react-bootstrap';
import { useDataStore } from '../Store';
import MultiLineChart from './MultipleLineChart';

const Metrics = () => {

    const selectedDealer = useDataStore((state) => state.selectedDealer);

    const [daysBack, setDaysBack] = useState(365);
    const [data, setData] = useState([]); // State to handle loading state
    const [loading, setLoading] = useState(true); // State to handle loading state
    const [error, setError] = useState(null);

    const fetchData = async () => {
        setLoading(true);

        const data = await getMetrics(selectedDealer, daysBack);
        if (data) {
            setData(data);
            setError(null);
        }
        else {
            setData([]);
            setError('Failed to fetch data');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [selectedDealer, daysBack]);

    const options = [
        { label: 'Last 365 days', daysBack: 365 },
        { label: 'Last 60 days', daysBack: 60 },
        { label: 'Last 30 days', daysBack: 30 },
        { label: 'Last 7 days', daysBack: 7 },
    ];

    return (
        <div style={{ padding: 10 }}>
            <Header title='Dashboard' description="View key performance indiactors over the last 365 days" />
            <Row className="justify-content-end">
                <ButtonGroup>
                    {options.map((option) => (
                        <Button
                            key={option.daysBack}
                            variant={daysBack === option.daysBack ? 'primary' : 'secondary'}
                            onClick={() => { setDaysBack(option.daysBack)}}
                            className="me-2"
                        >
                            {option.label}
                        </Button>
                    ))}
                </ButtonGroup>
            </Row>
            <br />
            <br />
            {loading ? <Loader /> : error ? <Error /> : (
                <>
                    {data?.StackedLines?.map((d) => (
                        <MultiLineChart key={d} data={d} />
                    ))}

                    <br />
                    <br />

                    {data?.StackedBars?.map((d) => (
                        <StackedKeyIndicatorChart key={d}  data={d} />
                    ))}
                </>
            )}
        </div>
    );
};

export default Metrics;
